import {OnClickReload, ReloadButton} from "components/src/common/ReloadButton";
import {usePageReloadContext} from "components/src/hook/UsePageReloadContext";
import {PageTitle, type PageTitleProps} from "components/src/layout/PageTitle";
import {useEffect} from "react";
import Row from "react-bootstrap/Row";

interface PageHeaderProps {
    icon: PageTitleProps["icon"];
    title: string;
    onClickReload?: OnClickReload;
}

export const PageHeader = ({icon, title, onClickReload}: PageHeaderProps) => {
    const {setReloadHandler} = usePageReloadContext();

    // let the sidebar reload this page when its menu item is clicked while it is active. A header without a handler,
    // such as the settings in a popup over a page, leaves the handler of the page alone
    useEffect(() => onClickReload ? setReloadHandler(onClickReload) : undefined, [onClickReload, setReloadHandler]);

    return (
        <Row className="px-4">
            <div className="d-flex flex-row align-items-center border-bottom mb-4">
                <div className="d-flex justify-content-start">
                    <PageTitle title={title} icon={icon}/>
                </div>
                <div className="d-flex flex-fill justify-content-end">
                    <ReloadButton onClickReload={onClickReload}/>
                </div>
            </div>
        </Row>
    );
};
